// import { useEffect } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
// import { FaTachometerAlt, FaAppStore, FaRegUser, FaUserCheck, FaWindowRestore, FaFileCode, FaBuffer } from "react-icons/fa";
import defineRoutes from "./../../helpers/defineRoutes.js";

const RenderRoutes = () => {
  return (
    <Routes>
      (
      {defineRoutes.map((r, i) => {
        return (
          <Route
            key={i}
            exact
            path={r.routeName}
            element={<r.component {...r.props} />}
          />
        );
      })}
      )
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default RenderRoutes;
